import React from 'react'
import {Link as RouterLink} from 'react-router-dom'
import {CardButtonBox, CardTitle, Divider} from '../BaseCard/styles'
import VideoIcon from '../../../../images/icons/new-dashboard/video-grey-icon.svg'
import VideoIconActive from '../../../../images/icons/new-dashboard/video-icon-active.svg'
import CalendarIcon from '../../../../images/icons/new-dashboard/add-calendar-icon.svg'
import LiveIcon from '../../../../images/icons/new-dashboard/live-icon.svg'
import LiveNow from '../../../../images/icons/new-dashboard/live-now.svg'
import {
  CardBox,
  ReportLinkBox,
  CardText,
  CardContent,
  IconBox,
  SpacingBox,
} from './styles'
import {Button} from '../../../../components/button'
import {Workshop} from '../../../../redux/workshop'
import {LinkBox} from '../../../../styles/global'
import {formatWorkshopDate} from '../../../../utils/formatWorkshopDates'
import {CalendarEvent, ics} from 'calendar-link'
import moment from 'moment-timezone'
import {useAppDispatch} from '../../../../redux/configureStore'
import {selectMember} from '../../../../redux/members'
import {useAuth} from '../../../../components/AuthProvider'
import ConflictedWorkshopDialog from '../../../../components/ConflictedWorkshopDialog'
import {useSelector} from 'react-redux'
import {CalendarAlertBox} from '../../../../pages/VirtualWorkshops/styles'
import CalendarAlert from '../../../../images/icons/calendar-alert-icon.svg'
import {handleUpgrade} from '../../../../utils/upgradeHelper'
import {MemberGroup} from '../../../../enums/memberGroups.enum'

type Props = {
  lastWorkshop?: Workshop
  nextWorkshop?: Workshop
  hasAccess: boolean
  courseId?: string
  conflictedWorkshop?: Workshop
  isConflictDialogOpen: boolean
  onChangeIsConflictDialogOpen: (value: boolean) => void
  onRsvp: () => void
  onLaunchWorkshop: () => void
  isSubmitting: boolean
}

const View = ({
  lastWorkshop,
  nextWorkshop,
  hasAccess,
  courseId,
  conflictedWorkshop,
  isConflictDialogOpen,
  onChangeIsConflictDialogOpen,
  onRsvp,
  onLaunchWorkshop,
  isSubmitting,
}: Props) => {
  const auth = useAuth()
  const dispatch = useAppDispatch()
  const member = useSelector(selectMember)

  const getEventData = (workshop?: Workshop) => {
    if (!workshop) return {} as CalendarEvent

    const startDate = new Date(workshop?.date)
    const endDate = new Date(workshop?.date)
    endDate.setHours(endDate.getHours() + 2)

    const centralStartDate = moment(startDate)
      .tz('America/Chicago')
      .format('YYYY-MM-DD HH:mm:ss ZZ')
    const centralEndDate = moment(endDate)
      .tz('America/Chicago')
      .format('YYYY-MM-DD HH:mm:ss ZZ')

    const response: CalendarEvent = {
      title: workshop?.title,
      description: workshop?.description,
      start: centralStartDate,
      end: centralEndDate,
      location: window.location.href,
    }

    return response
  }
  const handleDownload = (workshop?: Workshop) => {
    const response = decodeURIComponent(
      ics(getEventData(workshop)).replace(
        /^data:text\/calendar;charset=utf8,/,
        '',
      ),
    )

    const blob = new Blob([response], {type: 'text/calendar;charset=utf-8'})
    const url = window.URL.createObjectURL(blob)
    window.open(url)
  }

  const memberGroupEnabled =
    member?.groupId === MemberGroup.SuperAdmin ||
    member?.groupId === MemberGroup.Coach

  return (
    <CardBox>
      <CardTitle>
        <span>Virtual Workshops</span>
        {(nextWorkshop?.isLaunchEnabled ||
          (nextWorkshop?.isAdminEnabled && memberGroupEnabled)) && (
          <img src={LiveIcon} alt="Live" />
        )}
        <ReportLinkBox>
          <RouterLink to={`/virtual-workshops/${courseId}`}>
            See More
          </RouterLink>
        </ReportLinkBox>
      </CardTitle>
      <Divider />

      <SpacingBox>
        {nextWorkshop &&
          (nextWorkshop.isLaunchEnabled ||
            (nextWorkshop?.isAdminEnabled && memberGroupEnabled)) && (
            <CardContent>
              <CardText>
                <img src={LiveNow} alt="Live" />
                <br />
                Live: <span>{nextWorkshop.title}</span>
              </CardText>
              {hasAccess && (
                <IconBox onClick={onLaunchWorkshop}>
                  <img src={VideoIconActive} alt="Watch" />
                </IconBox>
              )}
            </CardContent>
          )}

        {lastWorkshop && hasAccess && (
          <CardContent>
            <CardText>
              Replay the Latest Workshop
              <br />
              <span>{lastWorkshop.title}</span>
            </CardText>
            <IconBox>
              <LinkBox
                component={RouterLink}
                to={`/workshops/replay/${lastWorkshop.workshopReplayId}`}
              >
                <img src={VideoIcon} alt="Watch" />
              </LinkBox>
            </IconBox>
          </CardContent>
        )}
        {nextWorkshop && (
          <>
            <CardContent>
              <CardText>
                Next Virtual Workshop
                <br />
                {nextWorkshop.displayAlert && (
                  <CalendarAlertBox>
                    <img src={CalendarAlert} alt="Date Changed" /> Date Changed
                  </CalendarAlertBox>
                )}
                <span>
                  {nextWorkshop.title}
                  <br />
                  {formatWorkshopDate(nextWorkshop.date)}
                </span>
              </CardText>
              {hasAccess && (
                <IconBox onClick={() => handleDownload(nextWorkshop)}>
                  <img src={CalendarIcon} alt="Add" />
                </IconBox>
              )}
            </CardContent>
            <CardButtonBox>
              {hasAccess ? (
                <Button
                  disabled={
                    !auth.isAuthenticated ||
                    !hasAccess ||
                    !nextWorkshop ||
                    isSubmitting
                  }
                  color={!nextWorkshop?.rsvp ? 'primary' : 'grey'}
                  children={!nextWorkshop?.rsvp ? 'RSVP' : 'UN-RSVP'}
                  onClick={onRsvp}
                />
              ) : (
                <Button
                  color="secondary"
                  children={'Upgrade to Expert'}
                  onClick={handleUpgrade(
                    dispatch,
                    auth,
                    member,
                    'virtual workshops paywall',
                  )}
                />
              )}
            </CardButtonBox>
          </>
        )}
      </SpacingBox>
      <ConflictedWorkshopDialog
        open={isConflictDialogOpen}
        setOpen={onChangeIsConflictDialogOpen}
        workshop={nextWorkshop}
        conflictedWorkshop={conflictedWorkshop}
      />
    </CardBox>
  )
}

export default View
